let libCache;

export function lib() {
    return new Promise((resolve) => {
        if (libCache) {
            resolve(libCache);
        } else {
            window.require(['idcta/idcta-1'], (idctaRequire) => {
                libCache = idctaRequire;
                resolve(libCache);
            });
        }
    });
}

export function refreshToken() {
    console.log('Token refresh initiated');

    return new Promise((resolve, reject) => {
        window.require(['idcta/idcta-1'], (idctaRequire) => {
            console.log('IDCTA', idctaRequire);
            idctaRequire.initiateTokenRefresh(undefined, undefined, true)
                .then((response) => {
                    console.log('Token refresh successful');
                    resolve(response);
                })
                .catch((err) => {
                    console.error('Token refresh failed', err);
                    reject(err);
                });
        });
    });
}



/** WEBPACK FOOTER **
 ** ./assets/js/idcta.js
 **/